import {
    toolDetailMap,
    toolActivesMap,
    toolImagesMap
  } from '@/settings/processImage'

export default {
  detail(state, tool) {
    return state[toolDetailMap.get(tool)]
  },
  images(state, tool) {
    return state[toolActivesMap.get(tool)]
  },
  actives(state, tool) {
    return state[toolImagesMap.get(tool)]
  }
}
